import Image from "next/image";
import { ImageAtomProps } from "./Image.types";

const ImageAtom = ({
  src,
  alt = "image",
  width,
  height,
  className = "",
  fill,
  priority = false,
}: ImageAtomProps) =>
  src &&
  (priority ? (
    <Image
      src={src}
      alt={alt}
      width={width}
      height={height}
      className={className}
      fill={fill}
      fetchPriority={'high'}
      loading="eager"
    />
  ) : (
    <Image
      src={src}
      alt={alt}
      width={width}
      height={height}
      className={className}
      fill={fill}
      loading="lazy"
    />
  ));

export default ImageAtom;
